export default class Debounce {
  private timerId: number | null = null;
  public constructor(private readonly delay: number) {}
  public run(fn: () => void) {
    return new Promise<void>((resolve) => {
      this.clear();
      const timerId = window.setTimeout(() => {
        if (this.timerId !== timerId) {
          console.error(
            'timerId mismatch. current is %d, old timerId is %d',
            this.timerId,
            timerId
          );
        }
        this.timerId = null;
        fn();
        resolve();
      }, this.delay);
      this.timerId = timerId;
    });
  }
  public clear() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}
